import { Link } from "react-router-dom";

export function Home() {
  return (
    <div className="container">
      <div className="card" style={{ textAlign: "center" }}>
        <img
          src="/logo.png"
          alt="Christian Church of Latter Rain"
          style={{ width: 64, height: 64, borderRadius: 14, boxShadow: "var(--shadow)", margin: "0 auto 1rem" }}
        />
        <h2 style={{ fontSize: "1.6rem" }}>Technology &amp; Audio Visual Support</h2>
        <p style={{ color: "var(--color-text-muted)" }}>
          Having a problem with sound, video, a computer, or the network? Let us know and our IT/AVL team will help.
        </p>

        <div className="home-actions">
          <Link to="/report" className="btn btn-primary btn-lg btn-full-row">
            🛠️ Report a Technology Problem
          </Link>
          <Link to="/status" className="btn btn-secondary">
            🔎 Check My Incident
          </Link>
          <Link to="/staff/login" className="btn btn-secondary">
            🔧 IT / AVL Team Login
          </Link>
        </div>
      </div>

      <div className="info-banner" style={{ marginTop: "1.5rem" }}>
        <strong>Need immediate help during worship?</strong> Please find a member of the AVL/IT team in person —
        this form is best for problems that aren't happening this exact second, or for after the fact.
      </div>
    </div>
  );
}
